module.exports = __webpack_public_path__ + "diligent-logotype-90abf87214f529c4ba9f0d0276a8fd08.svg";